export default __webpack_public_path__ + "static/circle-check-light.png";